export const navItems = [
	{
		title: "User",
		text: "User",
		icon: "fa-user",
		id: "user",
		selected: true,
		route: "/user/",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true,
	},
	{
        title: "Dashboard",
        text: "Dashboard",
		icon: "fa-gauge",
        id: "dashboards",
        route: "/dashboards/",
		orgAdminAllowed: true,        
        workspaceAdminAllowed: true
	},
	{
		title: "Configuration",
		text: "Configuration",
		icon: "fa-cog",
		id: "admin",
		expanded: false,
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},
	{
		title: "Workflows",
		text: "Workflows",
		icon: "fa-sitemap",
		id: "workflows",
		route: "/workflows/",
		parentId: "admin",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},
	{
		title: "Queries",
		text: "Queries",
		icon: "fa-list-alt",
		id: "queries",
		route: "/queries/",
		parentId: "admin",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},
	{
		title: "Service Groups",
		text: "Service Groups",
		icon: "fa-servicegroup",
		id: "servicegroups",
		route: "/servicegroups/",
		parentId: "admin",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},	
	{
		title: "Databases",
		text: "Databases",
		icon: "fa-database",
		id: "databases",
		route: "/databases/",
		parentId: "admin",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},	
	{
		title: "Data Lists",
		text: "Data Lists",
		icon: "fa-list",
		id: "datalists",
		route: "/datalists/",
		parentId: "admin",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},			
	{
		title: "File Sources",
		text: "File Sources",
		icon: "fa-folder-open-empty",
		id: "filesources",
		route: "/filesources/",
		parentId: "admin",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},	
	{
		title: "Key Files",
		text: "Key Files",
		icon: "fa-key",
		id: "keyfiles",
		route: "/keyfiles/",
		parentId: "admin",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},	
	{
		title: "Stamps",
		text: "Stamps",
		icon: "fa-certificate",
		id: "stamps",
		route: "/stamps",
		parentId: "admin",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},	
	{
		title: "Tools",
		text: "Tools",
		icon: "fa-wrench",
		id: "tools",
		expanded: false,
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},
	{
		title: "API Imports",
		text: "API Imports",
		icon: "fa-antenna",
		id: "apiimports",
		route: "/apiimports/",
		parentId: "tools",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},	
	{
		title: "Email Imports",
		text: "Email Imports",
		icon: "fa-mail",
		id: "emailimports",
		route: "/emailimports/",
		parentId: "tools",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},
	{
		title: "Location Imports",
		text: "Location Imports",
		icon: "fa-upload",
		id: "locationimports",
		route: "/locationimports/",
		parentId: "tools",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},	
	{
		title: "Custom Scripts",
		text: "Custom Scripts",
		icon: "fa-code",
		id: "customscripts",
		route: "/customscripts/",
		parentId: "tools",
		workspaceAdminAllowed: true,
		requiresWorkspace: true,
		requiresInstance: true
	},	
	{ 
		title: "System",
		text: "System",
		icon: "fa-cog-alt",
		id: "system",
		expanded: false,
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},	
	{ 
		title: "Organization",
		text: "Organization",
		icon: "fa-building",
		id: "organization",
		route: "/organization/",
		parentId: "system",
		orgAdminAllowed: true
	},
	{
		title: "Workspace",
		text: "Workspace",
		icon: "fa-bank",
		id: "workspace",
		route: "/workspace/",
		parentId: "system",
		workspaceAdminAllowed: true,
		requiresWorkspace: true
	},	
	{
		title: "Workspaces",
		text: "Workspaces",
		icon: "fa-bank",
		id: "workspaces",
		route: "/workspaces/",
		parentId: "system",
		orgAdminAllowed: true
	},	
	{
		title: "Instances",
		text: "Instances",
		icon: "fa-box",
		id: "instances",
		route: "/instances/",
		parentId: "system",
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},
	{
		title: "Categories",
		text: "Categories",
		icon: "fa-th-list",
		id: "categories",
		route: "/categories/",
		parentId: "system",
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},	
	{
		title: "Content Types",
		text: "Content Types",
		icon: "fa-docs",
		id: "documenttypes",
		route: "/documenttypes/",
		parentId: "system",
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},
	{
		title: "Attributes",
		text: "Attributes",
		icon: "fa-tag",
		id: "attributes",
		route: "/attributes/",
		parentId: "system",
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},	
	{
		title: "Roles",
		text: "Roles",
		icon: "fa-hammer",
		id: "roles",
		route: "/roles/",
		parentId: "system",
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},	
	{
		title: "Groups",
		text: "Groups",
		icon: "fa-users",
		id: "groups",
		route: "/groups/",
		parentId: "system",
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},	
	{
		title: "Users",
		text: "Users",
		icon: "fa-user",
		id: "users",
		route: "/users/",
		parentId: "system",
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},
	{
		title: "Satellites",
		text: "Satellites",
		icon: "fa-server",
		id: "satellites",
		route: "/satellites/",
		parentId: "system",
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},
	{ 
		title: "Control Panel",
		text: "Control Panel",
		icon: "fa-sliders",
		id: "control",
		expanded: false,
		orgAdminAllowed: true,
		workspaceAdminAllowed: false,
		requiresConstituo: true
	},
	{
		title: "Monitor",
		text: "Monitor",
		icon: "fa-calendar",
		id: "monitor",
		route: "/monitor/",
		parentId: "control",
		orgAdminAllowed: true,
		workspaceAdminAllowed: false,
		requiresConstituo: true
	},
	{
		title: "Thread Pools",
		text: "Thread Pools",
		icon: "fa-tasks",
		id: "threadpools",
		route: "/threadpools/",
		parentId: "control",
		orgAdminAllowed: true,
		workspaceAdminAllowed: false,
		requiresConstituo: true
	},
	{
		title: "Routines",
		text: "Routines",
		icon: "fa-calendar",
		id: "routines",
		route: "/routines/",
		parentId: "control",
		orgAdminAllowed: true,
		workspaceAdminAllowed: false,
		requiresConstituo: true
	},
	{ 
		title: "Filtered",
		text: "Filtered",
		icon: "fa-filter",
		id: "filtered",
		expanded: false,
		orgAdminAllowed: true,
		workspaceAdminAllowed: true
	},
];
